<template>
    <div class="warehouse-io__wrapper">
        <div class="warehouse-io">
            <div class="warehouse-io__name">
                {{ $tc("words.export") }} {{ warehouse.name }} {{ $tc("words.applications") }}
            </div>
            <form @submit.prevent="onSubmit" @reset.prevent="onReset">
                <div class="warehouse-io__content">
                    <form-textarea-group
                        :value="applicationsData"
                        :label="$tc('warehouses.jsonData')"
                        :rows="10"
                        :autofocus="true"
                    >
                    </form-textarea-group>
                </div>
                <div class="warehouse-io__controls">
                    <sah-button class="app__button_alt" type="reset">
                        {{ $tc("words.close") }}
                    </sah-button>
                    <sah-button type="submit">
                        {{ $tc("words.export") }}
                    </sah-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import {store, FormTextareaGroup, SahButton} from "atom";
const {createNamespacedHelpers} = store;
const {mapActions, mapState} = createNamespacedHelpers("arcman");
/**
 *
 * @vue-prop {Object} warehouse - warehouse
 */
export default {
    name: "warehouse-export",
    components: {
        FormTextareaGroup,
        SahButton,
    },
    props: {
        warehouse: {type: Object, required: true},
    },
    computed: {
        ...mapState(["warehouseExportedApplications"]),
        applicationsData() {
            return JSON.stringify(this.warehouseExportedApplications, undefined, 4);
        },
    },
    methods: {
        ...mapActions({
            warehouseExportApplications: "WAREHOUSE_EXPORT_APPLICATIONS",
        }),
        onReset() {
            this.$emit("cancel");
        },
        onSubmit() {
            let fileURL = window.URL.createObjectURL(
                new Blob([JSON.stringify(this.warehouseExportedApplications, null, 4)], {type: "application/json"})
            );
            let fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.setAttribute("download", "arcology.json");
            document.body.appendChild(fileLink);
            fileLink.click();
            document.body.removeChild(fileLink);
            this.$emit("end");
        },
    },
    mounted() {
        this.warehouseExportApplications({warehouse: this.warehouse});
    },
};
</script>

<style scoped lang="scss">
.warehouse-io__wrapper::v-deep {
    @apply fixed top-0 left-0 z-10 h-screen w-screen flex flex-row items-center justify-center;
    background-color: $background-wrapper-edit-color;

    .warehouse-io {
        @apply w-4/5 flex flex-col rounded border-solid border-2 max-h-screen overflow-y-auto;
        background-color: $background-application-color;
        @screen md {
            @apply w-3/5;
        }
        @screen xl {
            @apply w-2/5;
        }
        border-color: $border-card-color;
        font-size: $font-small;
    }

    .warehouse-io__name {
        @apply font-bold py-3 px-5;
        background-color: $background-card-header-color;
        color: $text-card-header-color;
    }

    .warehouse-io__content {
        @apply bg-white py-3 px-5 overflow-y-auto;
    }

    .warehouse-io__data {
        @apply outline-none appearance-none h-full w-full p-2 rounded border border-solid;
        border-color: $border-card-color;
    }

    .warehouse-io__controls {
        @apply flex justify-end py-3 px-5 mt-4;
        background-color: $background-card-footer-color;
    }
}
</style>
